import React, {Fragment, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import LookDropdown from "../../../ui/lookDropdown";
import {getAddressFromObject} from "../../../../popups/printPopup/printDocumentInfo";
import {restorePaymentInfo, setPaymentInfo} from "../../../../../actions/paymentFunctions";
import {ROUTES} from "../../../../../routes";


const GroheCartBillingDropdown = (props) => {

  const {billingAddress, setPaymentInfo, intl, history, billingSameAsShipping, shippingAddress, restorePaymentInfo} = props;
  const [valuesBeforeCheckbox, setValuesBeforeCheckbox] = useState(null);

  const changeAddressClick = () => {
    history.push(ROUTES.cartBillingInfo);
  }

  const sameAsShippingCheckboxClick = () => {
    const newValue = !billingSameAsShipping;
    setPaymentInfo("billingSameAsShipping", newValue);
    if (newValue) {
      setValuesBeforeCheckbox(billingAddress);
      restorePaymentInfo({
        billingAddress: shippingAddress
      });
    } else if (valuesBeforeCheckbox) {
      restorePaymentInfo({
        billingAddress: valuesBeforeCheckbox
      });
    }
  }

  const addresses = [];

  if (billingAddress.address1 || billingAddress.city) {
    addresses.push({
      text: (billingAddress.address1 ? (billingAddress.address1 + " ") : "") + getAddressFromObject(billingAddress),
      value: 0,
    })
  }

  return (
    <Fragment>
      <h2 className="gc-header__title">
        <FormattedMessage id="grohe.cart.billing.billing.title"/>
      </h2>
      <p className="gc-header__sub-title">
        <FormattedMessage id="grohe.cart.billing.billing.subTitle"/>
      </p>
      <LookDropdown className="gc-select"
                    textOnly={true}
                    selectLabel={intl.formatMessage({id: "grohe.cart.billing.address"}) + ":"}
                    selectItems={addresses}
                    selectedItem={addresses[0]}
                    selectItemClick={(selectItem, selectItemIndex) => setPaymentInfo("selectedBillingAddressIndex", selectItemIndex)}/>
      <div className="gc-content__change">
        <Button className="look-button--no-bg look-button--text look-button--no-transform nowrap"
                startIcon={<EditIcon/>}
                onClick={changeAddressClick}>
          <FormattedMessage id={
            billingAddress.address1 || billingAddress.city ? "grohe.cart.billing.changeAddress" : "grohe.cart.billing.addNewAddress"
          }/>
        </Button>
        <FormControlLabel
          label={intl.formatMessage({id: "grohe.cart.billing.billing.checkbox"})}
          className="gc-checkbox"
          control={(
            <Checkbox
              checked={billingSameAsShipping}
              onChange={sameAsShippingCheckboxClick}
            />
          )}
        />
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {billingAddress, billingSameAsShipping, shippingAddress} = store.paymentState;

  return {
    isMobile,
    billingAddress,
    billingSameAsShipping,
    shippingAddress,
  };
};

const mapDispatchToProps = {
  setPaymentInfo,
  restorePaymentInfo,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartBillingDropdown)
  )
)
